import {WlRangeSlider} from "./rangeSlider";
import {defineWebComponent} from "../webcomponents-utils";

export * from './rangeSlider.component';
export default WlRangeSlider;

defineWebComponent("wl-range-slider", WlRangeSlider);
